import { render, staticRenderFns } from "./thereServiceOpen.vue?vue&type=template&id=53490f6a&scoped=true&"
import script from "./thereServiceOpen.vue?vue&type=script&lang=js&"
export * from "./thereServiceOpen.vue?vue&type=script&lang=js&"
import style0 from "./thereServiceOpen.vue?vue&type=style&index=0&id=53490f6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53490f6a",
  null
  
)

export default component.exports